/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Entity_Sales_Credit_MemosInputs */



/**
* | output |
* | --- |
* | "Sales credit memos" |
*
* @param {Agent_Event_Entity_Sales_Credit_MemosInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_entity_sales_credit_memos = /** @type {((inputs?: Agent_Event_Entity_Sales_Credit_MemosInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Entity_Sales_Credit_MemosInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verkaufsgutschriften")
	return /** @type {LocalizedString} */ ("Sales credit memos")
});